export function accessoryProductFitsCarByID(accessoryProduct, carID) {
  return accessoryProduct?.fits
    ?.map((r) => r.id)
    ?.map(String)
    ?.includes(String(carID))
}
